import { BOSSESS, BOSSESS_REV } from "~/lib/enums";

export function toggleBodyScroll(value = false) {
  const overflow = value ? "hidden" : "auto";
  const htmlOverflow = value ? "hidden" : "";
  document.getElementsByTagName("body")[0].style.overflowY = overflow;
  document.getElementsByTagName("html")[0].style.overflowY = htmlOverflow;
}

export function getToken(key) {
  try {
    const serializedState = localStorage.getItem(key);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
}
export function saveToken(state, key) {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(key, serializedState);
  } catch (err) {
    console.log(err);
  }
}

export function getLocale() {
  return document?.querySelector("html")?.lang || "en";
}

export function paramsApi(params = {}) {
  const paramsBase = {
    locale: getLocale(),
  };

  const paramsReturn = {
    ...paramsBase,
    ...params,
  };

  return paramsReturn;
}

export function paramsToFormData(params) {
  let paramsBase = paramsApi();
  let paramsJson = JSON.parse(JSON.stringify(params));
  let formData = new FormData();
  for (const [key, value] of Object.entries(paramsJson)) {
    if (key === "avatar" && typeof params.avatar === "object") {
      if (params.avatar && typeof params.avatar === "object") {
        formData.append(key, params.avatar, params.avatar.name);
      }
    } else {
      if (typeof value === "object" && params[key] && !Array.isArray(value)) {
        let arr = Object.entries(JSON.parse(JSON.stringify(params[key])));
        for (let [key2, value2] of Object.entries(params[key])) {
          formData.append(key + "[]", value2);
        }
      } else if (Array.isArray(value)) {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, value);
      }
    }
  }
  return formData;
}

export function parseBlogDate(date) {
  const originalDate = new Date(date);

  const formattedDate = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  })
    .format(originalDate)
    .replace(/\//g, ".");

  return formattedDate;
}

export function camelToTitle(text) {
  const result = text.replace(/([A-Z])/g, " $1");
  return result.charAt(0) + result.slice(1).toLowerCase();
}

export function timeAgo(timestamp: any) {
  const currentDate: any = new Date();
  const originalDate: any = new Date(timestamp);
  const timeDifference = currentDate - originalDate;

  if (timeDifference < 1000) {
    return "Just now";
  } else if (timeDifference < 60 * 1000) {
    const secondsAgo = Math.floor(timeDifference / 1000);
    return `${secondsAgo} Second${secondsAgo !== 1 ? "s" : ""} Ago`;
  } else if (timeDifference < 60 * 60 * 1000) {
    const minutesAgo = Math.floor(timeDifference / (60 * 1000));
    return `${minutesAgo} Minute${minutesAgo !== 1 ? "s" : ""} Ago`;
  } else if (timeDifference < 24 * 60 * 60 * 1000) {
    const hoursAgo = Math.floor(timeDifference / (60 * 60 * 1000));
    return `${hoursAgo} Hour${hoursAgo !== 1 ? "s" : ""} Ago`;
  } else {
    const daysAgo = Math.floor(timeDifference / (24 * 60 * 60 * 1000));
    return `${daysAgo} Day${daysAgo !== 1 ? "s" : ""} Ago`;
  }
  return "";
}

export function expiryDate(unixTimestamp) {
  const date = new Date(unixTimestamp * 1000);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Note: JavaScript months are 0-based, so we add 1
  const year = date.getFullYear();

  const formattedDate = `${day}.${month}.${year}`;
  return formattedDate;
}
export function expiryTimestamp(timestamp) {
  const date = new Date(timestamp);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
}

export function restrictEmail(email: string, userId: number) {
  if (userId === 6) {
    const [name, domain] = email.split("@");

    const censoredName =
      name.length > 2
        ? name[0] + "*".repeat(name.length - 2) + name[name.length - 1]
        : "*".repeat(name.length); // e.g. "a" => "*", "ab" => "**"

    return `${censoredName}@${domain}`;
  }
  return email;
}
export function parseUnixCode(unixTimestamp) {
  const date = new Date(unixTimestamp * 1000);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Note: JavaScript months are 0-based, so we add 1
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  const formattedDate = `${day}.${month}.${year}, ${hours}:${minutes}`;
  return formattedDate;
}

export function parseOrderDate(date) {
  const originalDate = new Date(date);
  const dateFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  const timeFormatOptions = {
    hour: "2-digit",
    minute: "2-digit",
  };
  const formattedDate = originalDate
    .toLocaleDateString("en-GB", dateFormatOptions)
    .replace(/\//g, ".");
  const formattedTime = originalDate.toLocaleTimeString(
    "en-GB",
    timeFormatOptions
  );

  return `${formattedDate}, ${formattedTime}`;
}

export function formatDateDifference2(date1, date2) {
  // let diffMs = this.toMs(date2) - this.toMs(date1);
  let diffMs = new Date(date2) - new Date(date1);

  let totalSeconds = Math.floor(diffMs / 1000);
  let totalMinutes = Math.floor(totalSeconds / 60);
  let totalHours = Math.floor(totalMinutes / 60);
  let totalDays = Math.floor(totalHours / 24);

  return `${totalDays} d(s), ${totalHours % 24} h, ${totalMinutes % 60} m`;
}
export function formatDateDifference(date1, date2) {
  // let diffMs = this.toMs(date2) - this.toMs(date1);
  let diffMs = new Date(date2) - new Date(date1);

  let totalSeconds = Math.floor(diffMs / 1000);
  let totalMinutes = Math.floor(totalSeconds / 60);
  let totalHours = Math.floor(totalMinutes / 60);
  let totalDays = Math.floor(totalHours / 24);

  return `${totalDays} days, ${totalHours % 24} hours, ${
    totalMinutes % 60
  } minutes`;
}
export function formatDaysDifference(date1, date2) {
  // let diffMs = this.toMs(date2) - this.toMs(date1);
  let diffMs = new Date(date2) - new Date(date1);

  let totalSeconds = Math.floor(diffMs / 1000);
  let totalMinutes = Math.floor(totalSeconds / 60);
  let totalHours = Math.floor(totalMinutes / 60);
  let totalDays = Math.floor(totalHours / 24);

  return `${totalDays} Days ago`;
}

export function formatTimestamp(timestamp) {
  const date = new Date(timestamp);
  const month = date.toLocaleString("en-US", { month: "long" });
  const day = date.getDate();
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${month} ${day}, ${year} ${hours}:${minutes}`;
}

export function timestampToDateTime(date) {
  const timestampString = date;
  const timestamp = new Date(timestampString);
  const day = timestamp.getDate();
  const month = timestamp.toLocaleString("en-US", { month: "short" });
  const year = timestamp.getFullYear();

  return `${day} ${month.toUpperCase()} ${year}`;
}

export function timeStampToDate(date) {
  const dateObject = new Date(date);
  const year = dateObject.getFullYear();
  const month = String(dateObject.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
  const day = String(dateObject.getDate()).padStart(2, "0");
  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
}

export function formatOrderDetailDate(date) {
  const originalDate = new Date(date);
  const dateOptions = {
    month: "long",
    day: "numeric",
  };

  const timeOptions = {
    hour: "2-digit",
    minute: "2-digit",
  };

  const formattedDate = originalDate.toLocaleDateString("en-US", dateOptions);
  const formattedTime = originalDate.toLocaleTimeString("en-US", timeOptions);
  return `${formattedDate}, ${formattedTime}`;
}

// export function formatDateDifference(date1, date2) {
//   let diffMs = new Date(date2) - new Date(date1);

//   let totalSeconds = Math.floor(diffMs / 1000);
//   let totalMinutes = Math.floor(totalSeconds / 60);
//   let totalHours = Math.floor(totalMinutes / 60);
//   let totalDays = Math.floor(totalHours / 24);

//   return `${totalDays} days, ${totalHours % 24} hours, ${
//     totalMinutes % 60
//   } minutes`;
// }

export function getUserLocalTime(timezone) {
  const userTimeZone = timezone;
  if (timezone) {
    const options = {
      timeZone: userTimeZone,
      hour: "2-digit",
      minute: "2-digit",
    };
    const userTime = new Date().toLocaleString([], options);
    return userTime;
  } else {
    return "";
  }
}

export function timestampToHoursMinutes(time) {
  const laravelTimestamp = time;
  const date = new Date(laravelTimestamp);
  const options = { hour: "2-digit", minute: "2-digit" };
  const localTime = date.toLocaleTimeString(undefined, options);
  return localTime;
}

export function renderCoupon(coupon) {
  let discount = "";
  if (coupon.usage_type == 1) {
    discount = `-${coupon.discount}%`;
  } else if (coupon.usage_type == 2) {
    discount = `-${coupon.discount}`;
  }
  return discount;
}

export function showCouponReversedPrice(amount: any, coupon: any) {
  if (coupon) {
    if (coupon.usage_type == 1) {
      amount = amount + (amount * coupon.discount) / 100;
    } else if (coupon.usage_type == 2) {
      amount = amount + coupon.discount;
    }
  }
  return parseFloat(amount).toFixed(2);
}

export function mapDetails(
  details: any,
  gameId: any,
  packId: any,
  checkout: any
) {
  // LEAGUE OF LEGENDS
  if (packId === 1) {
    return {
      currentRank: details.currentRank,
      currentDivision: details.currentDivision,
      desiredRank: details.desiredRank,
      desiredDivision: details.desiredDivision,
      currentLp: details.currentRankLp,
      desiredLp: details.desiredRankLp,
    };
  } else if (packId === 2) {
    return {
      currentRank: details.currentRank,
      currentDivision: details.currentDivision,
      numberOfWins: details.numberOfGames,
      lpGain: details.currentRankLp,
    };
  } else if (packId === 3) {
    return {
      currentRank: details.currentRank,
      currentDivision: details.currentDivision,
      numberOfGames: details.numberOfGames,
      lpGain: details.currentRankLp,
    };
  } else if (packId === 4) {
    return {
      soulFighterRank: details.soulFighterRankTitle,
      numberOfGames: details.numberOfGames,
    };
  } else if (packId === 5) {
    return {
      currentTier: details.currentMasterySlab,
      desiredTier: details.desiredMasterySlab,
    };
  } else if (packId === 6) {
    return {
      tier: checkout.tier,
      numberOfGames: details.numberOfGames,
      numberOfBoosters: details.numberOfBoosters,
    };
  }
  // VALORANT
  else if (packId === 7) {
    return {
      currentRank: details.currentRank,
      currentDivision: details.currentDivision,
      desiredRank: details.desiredRank,
      desiredDivision: details.desiredDivision,
      rrCurrent: details?.currentRankLp || 0,
      rrDesired: details?.desiredRankLp || 0,
    };
  } else if (packId === 8) {
    return {
      currentRank: details.currentRank,
      currentDivision: details.currentDivision,
      numberOfGames: details.numberOfWins,
      rrCurrent: details?.currentRankLp || 0,
    };
  } else if (packId === 9) {
    return {
      currentRank: details.currentRank,
      currentDivision: details.currentDivision,
      numberOfGames: details.numberOfWins,
      rrCurrent: details?.currentRankLp || 0,
    };
  }

  // RAINBOW SIX SIEGE
  if (gameId === 3 && packId === 10) {
    return {
      currentRank: details.currentRank,
      desiredRank: details.desiredRank,
      currentDivision: details.currentDivision,
      desiredDivision: details.desiredDivision,
    };
  } else if (gameId === 3 && packId === 11) {
    return {
      // NET WINS BOOST
      currentRank: details.currentRank,
      currentDivision: details.currentDivision,
      numberOfWins: details.numberOfWins,
    };
  }

  // ROCKET LEAGUE
  else if (packId === 12) {
    //rocket-league-rank-boost
    return {
      currentRank: details.currentRank,
      currentDivision: details.currentDivision,
      desiredRank: details.desiredRank,
      desiredDivision: details.desiredDivision,
    };
  } else if (packId === 13 || packId === 14 || packId === 16) {
    //rocket-league-wins-boost
    //rocket-league-rewards-boost
    //rocket-league-placement-boost
    return {
      currentRank: details.currentRank,
      currentDivision: details.currentDivision,
      numberOfGames: details.numberOfWins,
    };
  } else if (packId === 15) {
    return {
      currentRank: details.currentRank,
    };
  }

  // OVERWATCH
  else if (packId === 21 && gameId === 6) {
    //ow-rank-boost
    return {
      currentRank: details.currentRank,
      currentDivision: details.currentDivision,
      desiredRank: details.desiredRank,
      desiredDivision: details.desiredDivision,
    };
  } else if (packId === 22) {
    //ow-win-boost
    return {
      currentRank: details.currentRank,
      currentDivision: details.currentDivision,
      numberOfWins: details.numberOfWins,
    };
  } else if (packId === 23) {
    //ow-placements-boost
    return {
      currentRank: details.currentRank,
      currentDivision: details.currentDivision,
      numberOfGames: details.numberOfGames,
    };
  }

  // COUNTER STRIKE 2
  else if (packId === 24) {
    return {
      currentRankPoints: details.rankFrom,
      desiredRankPoints: details.rankTo,
      currentRank: details.currentRank,
      desiredRank: details.desiredRank,
    };
  } else if (packId === 25) {
    return {
      currentRankPoints: details.rankFrom,
      numberOfWins: details.numberOfWins,
    };
  } else if (packId === 43 || packId === 44) {
    return {
      faceitCurrentDivision: details.rankFrom,
      faceitDesiredDivision: details.rankTo,
      currentRank: details.currentDivisionTitle,
      desiredRank: details.desiredDivisionTitle,
    };
  } else if (packId === 45) {
    return {
      faceitCurrentDivision: details.rankFrom,
      numberOfWins: details.numberOfWins,
    };
  } else if (packId === 46) {
    return {
      numberOfGames: details.numberOfGames,
    };
  }

  // DOTA 2
  else if (packId === 17) {
    //dota-2-mmr-boost-service
    let otherParams = {};
    return {
      currentRank: details.currentRank,
      desiredRank: details.desiredRank,
      currentRankPoints: details.rankFrom,
      desiredRankPoints: details.rankTo,
      // ...otherParams,
    };
  } else if (packId === 18) {
    //dota-2-win-rate-boosting
    return {
      currentRank: details.currentRank,
      numberOfWins: details.numberOfWins,
    };
  } else if (packId === 19) {
    //dota-2-calibration-boost
    let otherParams = {};
    if (details.currentRankTitle !== "Immortal") {
      otherParams = {
        ...otherParams,
        currentDivision: details.currentDivision,
      };
    }
    if (details.currentRankTitle === "Immortal") {
      otherParams = {
        ...otherParams,
        currentImmortalPoints: details.currentRankLp,
      };
    }
    return {
      currentRank: details.currentRank,
      numberOfGames: details.numberOfGames,
      ...otherParams,
    };
  } else if (packId === 20) {
    //dota-2-low-priority-removal
    let otherParams = {};
    if (details.currentRankTitle !== "Immortal") {
      otherParams = {
        ...otherParams,
        currentDivision: details.currentDivision,
      };
    }
    if (details.currentRankTitle === "Immortal") {
      otherParams = {
        ...otherParams,
        currentImmortalPoints: details.currentRankLp,
      };
    }
    return {
      currentRank: details.currentRank,
      numberOfGames: details.numberOfGames,
      ...otherParams,
    };
  }

  // APEX LEGENDS
  else if (gameId === 8 && packId === 26) {
    return {
      currentRankPoints: details.rankFrom,
      desiredRankPoints: details.rankTo,
      currentRank: details.currentRank,
      currentDivision: details.currentDivision,
      desiredRank: details.desiredRank,
      desiredDivision: details.desiredDivision,
    };
  } else if (gameId === 8 && packId === 27) {
    return {
      rank: details.currentRank,
      numberOfGames: details.numberOfGames,
    };
  } else if (gameId === 8 && packId === 28) {
    return {
      rank: details.currentRank,
      numberOfWins: details.numberOfWins,
    };
  } else if (gameId === 8 && packId === 29) {
    return {
      achievements: [...checkout.getSelectedBadges],
    };
  }

  // FORTNITE
  else if (packId === 47 || packId === 60 || packId === 76) {
    //fortnite-rank-boost
    let otherParams = {};
    if (details.currentDivision) {
      otherParams = {
        ...otherParams,
        currentDivision: details.currentDivision,
      };
    }
    if (details.desiredDivision) {
      otherParams = {
        ...otherParams,
        desiredDivision: details.desiredDivision,
      };
    }
    return {
      currentRank: details.currentRank,
      desiredRank: details.desiredRank,
      ...otherParams,
    };
  } else if (packId === 48) {
    //fortnite-wins-boost
    let otherParams = {};
    if (details.currentDivision) {
      otherParams = {
        ...otherParams,
        currentDivision: details.currentDivision,
      };
    }
    return {
      currentRank: details.currentRank,
      numberOfWins: details.numberOfWins,
      ...otherParams,
    };
  }

  // TEAMFIGHTTACTICS
  else if (packId === 49) {
    return {
      currentRank: details.currentRank,
      currentDivision: details.currentDivision,
      desiredRank: details.desiredRank,
      desiredDivision: details.desiredDivision,
      currentLp: details.currentRankLp,
      desiredLp: details.desiredRankLp,
    };
  } else if (packId === 50) {
    return {
      currentRank: details.currentRank,
      currentDivision: details.currentDivision,
      desiredRank: details.desiredRank,
      desiredDivision: details.desiredDivision,
      currentLp: details.currentRankLp,
      desiredLp: details.desiredRankLp,
    };
  } else if (packId === 51) {
    return {
      currentMmr: details.currentMmr,
      desiredMmr: details.desiredMmr,
    };
  } else if (packId === 52) {
    return {
      currentRank: details.currentRank,
      currentDivision: details.currentDivision,
      numberOfWins: details.numberOfWins,
      currentLp: details.currentRankLp,
    };
  } else if (packId === 53) {
    return {
      currentRank: details.currentRank,
      currentDivision: details.currentDivision,
      numberOfGames: details.numberOfGames,
      currentLp: details.currentRankLp,
    };
  }

  // THEFINALS
  else if (packId === 55) {
    let otherParams = {};

    if (
      details.currentRankTitle === "Diamond" &&
      details.currentDivisionTitle === "1"
    ) {
      otherParams = {
        ...otherParams,
        currentRp: details.currentRankLp,
      };
    }

    if (
      details.desiredRankTitle === "Diamond" &&
      details.desiredDivisionTitle === "1"
    ) {
      otherParams = {
        ...otherParams,
        desiredRp: details.desiredRankLp,
      };
    }
    return {
      currentRank: details.currentRank,
      currentDivision: details.currentDivision,
      desiredRank: details.desiredRank,
      desiredDivision: details.desiredDivision,
      ...otherParams,
    };
  } else if (packId === 56) {
    let otherParams = {};

    if (
      details.currentRankTitle === "Diamond" &&
      details.currentDivisionTitle === "1"
    ) {
      otherParams = {
        ...otherParams,
        currentRp: details.currentRankLp,
      };
    }
    return {
      currentRank: details.currentRank,
      currentDivision: details.currentDivision,
      numberOfWins: details.numberOfWins,
      ...otherParams,
    };
  } else if (packId === 57) {
    return {
      numberOfRounds: details.numberOfRounds,
    };
  } else if (packId === 58) {
    return {
      currentBpLevel: details.currentBp,
      desiredBpLevel: details.desiredBp,
    };
  } else if (packId === 59) {
    return {
      gadgetsAndWeapons: details.gadgetsAndWeapons,
    };
  }
  // ELEARNING
  else if (
    packId === 32 ||
    packId === 33 ||
    packId === 34 ||
    packId === 35 ||
    packId === 36 ||
    packId === 37 ||
    packId === 38 ||
    packId === 39 ||
    packId === 40 ||
    packId === 41 ||
    packId === 42 ||
    packId === 54
  ) {
    let eLearning = 1;
    let key = "";
    let value = 1;
    if (details.elearningTitle === "Coaching") {
      eLearning = 1;
    } else if (details.elearningTitle === "VoD Review") {
      eLearning = 2;
    } else if (details.elearningTitle === "Play & Learn") {
      eLearning = 3;
    }
    if (details?.numberOfHours) {
      key = "numberOfHours";
      value = details?.numberOfHours;
    } else if (details?.vodReviews) {
      key = "vodReviews";
      value = details?.vodReviews;
    } else if (details?.numberOfGames) {
      key = "numberOfGames";
      value = details?.numberOfGames;
    }
    return {
      eLearning: eLearning,
      [key]: value,
    };
  }
  // UNRATED
  else if (
    packId === 66 ||
    packId === 67 ||
    packId === 68 ||
    packId === 69 ||
    packId === 70 ||
    packId === 71 ||
    packId === 72 ||
    packId === 73 ||
    packId === 74 ||
    packId === 75 ||
    packId === 93
  ) {
    return {
      numberOfGames: details.numberOfGames,
    };
  }

  // camo-boosting
  else if (packId === 77 || packId === 83 || packId === 90) {
    let weapons = checkout.getCamoWeapon?.map((wp) => ({
      weapon_id: wp.id,
      category_id: wp.category_id,
    }));
    let camoSpecial = {};
    if (checkout.getCamoSpecials?.id) {
      camoSpecial = {
        id: checkout.getCamoSpecials?.id,
      };
      weapons = [];
    }
    return {
      weapons: weapons,
      camoSpecial,
    };
  } else if (packId === 78) {
    return {
      currentPrestige: details?.currentPrestige,
      desiredPrestige: details?.desiredPrestige,
      currentPrestigeLevel: details?.currentPrestigeLevel,
      desiredPrestigeLevel: details?.desiredPrestigeLevel,
    };
  } else if (packId === 79) {
    return {
      currentLvl: details?.currentLevel,
      desiredLvl: details?.desiredLevel,
      weapon: checkout.getCamoWeapon[0]?.id,
    };
  } else if (packId === 80) {
    return {
      nukeItems: details?.items || [],
    };
  } else if (packId === 81 || packId === 89) {
    return {
      reticleItems: details?.items || [],
    };
  } else if (packId === 91) {
    return {
      currentRank: details.currentRank,
      currentDivision: details.currentDivision,
      desiredRank: details.desiredRank,
      desiredDivision: details.desiredDivision,
      currentRankPoints: details.currentRankPoints,
      desiredRankPoints: details.desiredRankPoints,
    };
  } else if (packId === 95) {
    return {
      currentRank: details.currentRank,
      currentDivision: details.currentDivision || "null",
      desiredRank: details.desiredRank,
      desiredDivision: details.desiredDivision || "null",
    };
  } else if (packId === 92) {
    return {
      currentRank: details.currentRank,
      currentDivision: details.currentDivision,
      numberOfWins: details.numberOfWins,
      currentRankPoints: details.currentRankPoints,
    };
  } else if (packId === 94) {
    return {
      achievements: [...checkout.getSelectedBadges],
    };
  } else if (packId === 102) {
    return {
      currentRank: details.currentRankSlab,
      desiredRank: details.desiredRankSlab,
    };
  } else if (packId === 103) {
    return {
      numberOfOrbs: details.numberOfOrbs,
      orbId: details.orbId,
    };
  } else if (packId === 107) {
    return {
      currentLvl: details.currentLevel,
      desiredLvl: details.desiredLevel,
    };
  } else if (packId === 108) {
    return {
      gearId: details.gearId,
    };
  } else if (packId === 106) {
    return {
      trials: details.trials?.map((trial: any) => trial.id),
    };
  } else if (packId === 105) {
    return {
      acts: details.acts?.map((trial: any) => trial.id),
    };
  } else if (packId === 109) {
    return {
      currentRankPoints: details.currentRankPoints,
      desiredRankPoints: details.desiredRankPoints,
    };
  } else if (packId === 110) {
    return {
      currentRankPoints: details.currentRankPoints,
      desiredRankPoints: details.desiredRankPoints,
    };
  } else if (packId === 113) {
    return {
      coins: details.coins,
    };
  } else if (packId === 114) {
    return {
      numberOfHours: details.numberOfHours,
    };
  } else if (packId === 115) {
    return {
      numberOfWins: details.numberOfWins,
      difficultyTitle: details.difficultyTitle,
    };
  } else if (packId === 116) {
    let objectiveKey = "";
    switch (details.objectiveTitle) {
      case "Daily Objectives":
        objectiveKey = "Days";
        break;

      case "Weekly Objectives":
        objectiveKey = "Weeks";
        break;

      case "Weekly Play Completionist":
        objectiveKey = "Completions";
        break;

      case "Season Play":
        objectiveKey = "Games";
        break;

      case "Hourly Boosting":
        objectiveKey = "Hours";
        break;
      default:
    }
    return {
      numberOfObjectives: details.numberOfObjectives,
      objectiveTitle: details.objectiveTitle,
      objectiveKey: objectiveKey,
    };
  } else if (packId === 111) {
    return {
      desiredRank: details.desiredRank?.id,
    };
  } else if (packId === 117) {
    return {
      numberOfWins: details?.numberOfWins,
    };
  } else if (packId === 112) {
    let mapParams = {};

    switch (details?.boostType) {
      case "Division Boost":
        mapParams = {
          optionSlabs: details?.optionSlabs || [],
        };
        break;
      case "Qualification Points":
        mapParams = {
          numberOfRivalPoints: details?.numberOfRivalPoints || 0,
        };
        break;
      default:
    }
    return {
      boostType: details?.boostType,
      ...mapParams,
    };
  } else if (packId === 118) {
    return {
      optionSlabs: details?.optionSlabs,
      numberOfWins: details?.numberOfWins,
    };
  } else if (packId === 119) {
    return {
      numberOfGalacticGuns: details?.numberOfGalacticGuns,
      numberOfPoints: details?.numberOfPoints || 0,
      currentRank: details?.currentRank?.title,
    };
  } else if (packId === 120) {
    return {
      currentRank: details?.currentRank,
      currentDrive: details?.currentDrive,
      desiredDrive: details?.desiredDrive || 0,
    };
  } else if (packId === 121) {
    return {
      currentRankSlab: details?.currentRankSlab,
      desiredRankSlab: details?.desiredRankSlab,
    };
  } else if (packId === 122) {
    return {
      numberOfWins: details?.numberOfWins,
    };
  } else if (packId === 123) {
    return {
      currentRankPoints: details.currentRankPoints,
      desiredRankPoints: details.desiredRankPoints,
      currentRank: details.currentRank,
      desiredRank: details.desiredRank,
    };
  } else if (packId === 124) {
    return {
      currentRank: details.currentRank,
      currentDivision: details.currentDivision || "null",
      desiredRank: details.desiredRank,
      desiredDivision: details.desiredDivision || "null",
    };
  }

  return {};
}

export function mapMmoDetails(details, gameId, packId, checkout) {
  let otherParams = {};
  if (gameId === 1 && packId === 1) {
    if (checkout.armorType) {
      otherParams = {
        ...otherParams,
        armorType: checkout.armorType,
      };
    }
    return {
      keystoneLvl: details.desiredKeystone,
      numberOfRuns: details.numberOfMythic,
      ...otherParams,
    };
  }
  if (gameId === 1 && packId === 3) {
    return {
      currentLvl: details?.currentLevel,
      desiredLvl: details?.desiredLevel,
    };
  }
  if (gameId === 1 && packId === 2) {
    return {
      raidDifficulty: details.difficultyTitle,
      lootType: details.lootType,
      numberOfBosses: BOSSESS[details.bosses],
    };
  }
  if (gameId === 1 && packId === 6) {
    if (checkout.becomeLegend) {
      otherParams = {
        becomeLegend: true,
      };
    }
    return {
      currentRankPoints: details.currentRating,
      desiredRankPoints: details.desiredRating,
      ...otherParams,
    };
  }
  if (gameId === 1 && packId === 7) {
    return {
      currentRankPoints: details.currentRating,
      desiredRankPoints: details.desiredRating,
    };
  }
  if (gameId === 1 && packId === 8) {
    if (checkout.becomeGladiator) {
      otherParams = {
        becomeGladiator: true,
      };
    }
    return {
      currentRankPoints: details.currentRating,
      desiredRankPoints: details.desiredRating,
      ...otherParams,
    };
  }
  if (gameId === 1 && (packId === 9 || packId === 16)) {
    return {
      currentRankPoints: details.currentRating,
      desiredRankPoints: details.desiredRating,
    };
  }
  if (gameId === 1 && packId === 10) {
    return {
      honor: details.desiredHonour,
    };
  }
  if (gameId === 1 && packId === 11) {
    return {
      conquestPoints: details.desiredConquest,
    };
  }
  if (gameId === 1 && packId === 12) {
    return {
      gold: details.numberOfGold,
    };
  }
}
export function secondsToHoursOnly(seconds) {
  if (seconds === 0) {
    return "Instant";
  }
  if (seconds <= 0) {
    return "1 hour";
  }

  const totalHours = Math.floor(seconds / 3600);
  const days = Math.floor(totalHours / 24);
  const hours = totalHours % 24;

  if (totalHours < 1) {
    return "1 hour";
  }

  const dayStr = days > 0 ? `${days} ${days === 1 ? "day" : "days"}` : "";
  const hourStr =
    hours > 0 || totalHours < 24
      ? `${hours} ${hours === 1 ? "hour" : "hours"}`
      : "";

  return [dayStr, hourStr].filter(Boolean).join(", ");
}

export function secondsToDays(seconds) {
  if (seconds <= 0) {
    return "0 Day";
  }
  seconds = Number(seconds);
  const d = Math.floor(seconds / (3600 * 24));
  const h = Math.floor((seconds % (3600 * 24)) / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);

  const days = d > 0 ? d + (d == 1 ? " day, " : " days, ") : "";
  const hours = h > 0 ? h + "h " : "";
  const minutes = m > 0 ? m + "m " : "";
  const second = s > 0 ? s + "s " : "";
  return days + hours + minutes + second;
}
export function handleCurrency(currency) {
  if (currency === 1) {
    return "$";
  } else if (currency === 2) {
    return "€";
  } else if (currency === 3) {
    return "£";
  } else if (currency === 4) {
    return "€";
  } else if (currency === 5) {
    return "A$";
  } else if (currency === 6) {
    return "C$";
  } else if (currency === 7) {
    return "S$";
  }
  return "$";
}

export function insertToArray(arr, index, ...newItems) {
  return [
    // part of the array before the specified index
    ...arr.slice(0, index),
    // inserted items
    ...newItems,
    // part of the array after the specified index
    ...arr.slice(index),
  ];
}

export function convertArrayOfStringToSlug(array) {
  const newArray = array.map((item) => {
    const slug = item.toLowerCase().replace(/\s/g, "-");
    return { title: item, slug: slug };
  });

  return newArray;
}
export function formatSlugToTitle(slug) {
  if (!slug) {
    return "";
  }
  const words = slug.split("-");
  const title = words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return title;
}

export function formatChatHeaderTime(inputTime) {
  const date = new Date(inputTime);

  // Format the date in the local time zone
  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  return formattedTime;
}
export function formatNotificationTime(inputTime) {
  const date = new Date(inputTime);
  const now = new Date();
  const timeDifference = now - date;

  // Calculate time difference in minutes, hours, and days
  const minutesAgo = Math.floor(timeDifference / (1000 * 60));
  const hoursAgo = Math.floor(timeDifference / (1000 * 60 * 60));
  const daysAgo = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

  // Create a function to format the time difference
  if (minutesAgo < 1) {
    return "just now";
  } else if (minutesAgo < 60) {
    return minutesAgo === 1 ? "1 minute ago" : minutesAgo + " minutes ago";
  } else if (hoursAgo < 24) {
    return hoursAgo === 1 ? "1 hour ago" : hoursAgo + " hours ago";
  } else {
    return daysAgo === 1 ? "1 day ago" : daysAgo + " days ago";
  }
}

export function addCanonicalLink(localedHref = "") {
  // const { locale } = useI18n();
  // const href = `/${localedHref?.split(`/${locale.value}/`)[1] || ""}`;
  // const route = useRoute();
  // const app = useNuxtApp();
  // const links = app.$localeHead({
  //   addCanonicalLink: true,
  // });

  // if (route.name !== "blogs" && route.name !== "single_blog") {
  //   const allowedLanguages = [
  //     "en",
  //     "it",
  //     "fr",
  //     "es",
  //     "de",
  //     "nl",
  //     "pt",
  //     "uk",
  //     "ru",
  //   ];

  //   let mappedLinks = links?.link?.map((link) => {
  //     let hreflang = link.hreflang === "x-default" ? "en" : link.hreflang;
  //     if (!hreflang) {
  //       hreflang = locale.value;
  //     }
  //     return {
  //       // ...link,
  //       rel: link.rel,
  //       hreflang: link.hreflang,
  //       href: "https://boostingmarket.com" + `/${hreflang}` + href,
  //     };
  //   });

  //   mappedLinks = [...mappedLinks]
  //     // ?.filter((link) => link.hreflang !== "x-default")
  //     ?.reverse();
  //   useHead({
  //     link: [...mappedLinks],
  //   });
  // }
}
export function downloadFile(response, fileName) {
  const fileURL = window.URL.createObjectURL(new Blob([response]));
  const fileLink = document.createElement("a");
  fileLink.href = fileURL;
  fileLink.setAttribute("download", fileName);
  document.body.appendChild(fileLink);
  fileLink.click();
}

export const previousMessageDate = (
  currentMessage: any,
  previousMessage: any
) => {
  if (previousMessage) {
    return false;
  }
  if (!previousMessage) {
    return true;
  }
  return false;
};

export const nextMessageDate = (currentMessage: any, nextMessage: any) => {
  if (!nextMessage?.message) {
    return false;
  }

  const currentDate = new Date(currentMessage.created_at).toLocaleDateString();
  const nextDate = new Date(nextMessage.created_at).toLocaleDateString();

  if (currentDate === nextDate) {
    return false;
  } else {
    return true;
  }
};

export const handleDate = (time: any) => {
  const date = new Date(time);
  const d = date.toLocaleDateString(undefined, {
    weekday: "long",
    month: "long",
    day: "2-digit",
  });
  if (d) return d;
  return "";
};

export const handleAvatar = (avatar: string, url: string): string => {
  if (!avatar) {
    return "/images/logo.webp";
  }
  if (avatar?.includes("https://api.boostingmarket.com")) {
    return avatar;
  } else if (avatar?.includes("http://localhost:8000")) {
    return avatar;
  } else if (avatar?.includes("http://127.0.0.1:8000")) {
    return avatar;
  } else if (avatar?.includes(url)) {
    return avatar;
  }
  return `${url}${avatar}`;
};

export const renderPrice = (packOption: any) => {
  if (packOption.type === "free") {
    return packOption.type;
  } else if (packOption.type === "variable") {
    return `+${packOption.price}%`;
  } else if (packOption.type === "fixed") {
    return `+${parseFloat(packOption.price).toFixed(2)}$`;
  } else {
    return `+${parseFloat(packOption.price).toFixed(2)}`;
  }
};
export function convertPascalCaseToNormal(text) {
  if (!text) return "";
  const withSpaces = text.replace(/([A-Z])/g, " $1");
  const normalized = withSpaces.trim();
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
}

export function renderBossPrice(item) {
  if (item.type === "fixed") {
    return `$${item.value}`;
  } else {
    return `${item.value}%`;
  }
}
